export default "__VITE_ASSET__B0dEUe9y__"